import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { renderInputField, renderCheckboxes } from '../../../common/inputField';
import { useDispatch, useSelector } from 'react-redux';
import {
  deletePatientUploadedFiles,
  setPatientData,
  setPatientUploadedFiles,
} from '../../../actions';
import { CustomTextArea } from '../../../common/CustomTextArea';
import FileUploadCard from '../../../components/FileManager/FileUploadCard';
import FileDocumentCard from '../../../components/FileManager/FileDocumentCard';
import { toast } from 'sonner';
import {
  updateFileStatusUploaded,
  uploadPatientFileApi,
} from '../../../api/patientApi';
import { deleteFileApi } from '../../../api/fileApi';
import { useParams } from 'react-router-dom';

const InfertilityDetails = () => {
  const dispatch = useDispatch();
  const infertilityDetails = useSelector(
    (state) => state.clinicalReducer.infertilityDetails,
  );
  const { id: patientId } = useParams();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(setPatientData(`infertilityDetails.${name}`, value));
  };

  const handleCauseCheckboxChange = (e, index) => {
    const { name, checked } = e.target;
    const updatedCheckboxes = infertilityDetails.causeOfInfertilityType.map(
      (item, idx) => (idx === index ? { ...item, checked } : item),
    );
    if (name === 'otherValue') {
      dispatch(
        setPatientData(
          'infertilityDetails.causeOfInfertilityTypeOther',
          e.target.value,
        ),
      );
    } else {
      dispatch(
        setPatientData(
          'infertilityDetails.causeOfInfertilityType',
          updatedCheckboxes,
        ),
      );
    }
  };
  const handleTypeCheckboxChange = (e, index) => {
    const { name } = e.target;
    dispatch(setPatientData('infertilityDetails.infertilityType', name));
  };

  const uploadedFiles = useSelector(
    (state) => state.clinicalReducer.uploadedFiles,
  );
  const setUploadedFiles = (files) => {
    dispatch(setPatientUploadedFiles(files));
  };
  const [loadingText, setLoadingText] = useState('');

  const handleUpload = async (file, patientId) => {
    if (!patientId) return toast.error('Patient not created');
    return new Promise((resolve, reject) => {
      try {
        toast.promise(
          uploadPatientFileApi(
            file,
            patientId,
            'Patient',
            updateFileStatusUploaded,
            'Infertility',
          ),
          {
            loading: 'Uploading file...',
            success: (data) => {
              setUploadedFiles({ file: data, fileTag: 'Infertility' });
              // setLoading(false);
              return resolve(data);
            },
            error: (err) => {
              reject('Failed to upload docs');
            },
            duration: 100,
          },
        );
      } catch (err) {
        // setLoading(false);
        setLoadingText('');
        toast.error('Failed to upload file');
      }
    });
  };
  const handleDeleteFile = async (file) => {
    try {
      await deleteFileApi('patient', patientId, file.id);
      dispatch(deletePatientUploadedFiles(file));
      toast.success('File deleted successfully');
    } catch (err) {
      toast.error('Error deleting file');
    }
  };
  return (
    <div className="container-fluid">
      <div className="card">
        <div className="body">
          <div className="card_name_container" style={{ maxWidth: 400 }}>
            <label>Infertility Type</label>
            <label className="fancy-checkbox">
              <input
                type="checkbox"
                name={'Primary'}
                checked={infertilityDetails.infertilityType === 'Primary'}
                onChange={handleTypeCheckboxChange}
              />
              <span>Primary</span>
            </label>
            <label className="fancy-checkbox">
              <input
                type="checkbox"
                name={'Secondary'}
                checked={infertilityDetails.infertilityType === 'Secondary'}
                onChange={handleTypeCheckboxChange}
              />
              <span>Secondary</span>
            </label>
          </div>
          {renderCheckboxes(
            infertilityDetails.causeOfInfertilityType,
            handleCauseCheckboxChange,
            'Cause of Infertility',
            'causeOfInfertilityType',
            infertilityDetails.causeOfInfertilityTypeOther,
            true
          )}

          <p className="lead">Comments</p>
          <CustomTextArea
            value={infertilityDetails.infertilityComment}
            onChange={handleInputChange}
            name="infertilityComment"
            maxRows={10}
          />
          <div style={{ paddingTop: '50px' }}>
            <div className="row clearfix">
              <FileUploadCard
                // setFiles={setFiles}
                setUploadedFiles={setUploadedFiles}
                files={uploadedFiles}
                handleUpload={handleUpload}
                id={patientId}
              />
              {uploadedFiles.map((uploadedFile, i) => {
                const data = uploadedFile.file;

                if (uploadedFile.fileTag !== 'Infertility') return null;
                return (
                  <FileDocumentCard
                    key={i}
                    DocumentName={data.displayFileName}
                    DocumentSize={(data.size / 1024).toFixed(2) + ' KB'}
                    DocumentDate={new Date(data.updatedAt).toLocaleDateString()}
                    ImageUrl={
                      data?.fileType?.includes('image')
                        ? data.presignedUrl
                        : undefined
                    }
                    handleDeleteFile={() => handleDeleteFile(data)}
                    file={data}
                    fileUniquePrefix={`patient-${patientId}`}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfertilityDetails;
